import { HStack, Icon } from "@chakra-ui/react";
import { FiZap } from "react-icons/fi";
import CDS from "design-system";

interface AssignmentPillProps {
  autoAdd: boolean;
}

export default function AssignmentPill({ autoAdd }: AssignmentPillProps) {
  if (autoAdd) {
    return (
      <CDS.Tag variant={CDS.Tag.variant.primary} size={CDS.Tag.size.medium}>
        <HStack as="span" spacing={1} align="center">
          <Icon as={FiZap} boxSize={3.5} />
          <span>Auto · new hires</span>
        </HStack>
      </CDS.Tag>
    );
  }

  return (
    <CDS.Tag variant={CDS.Tag.variant.neutral} size={CDS.Tag.size.medium}>
      Manual
    </CDS.Tag>
  );
}
